<div class="content timing-page">

    <!--BACKYARD BUILD OUT-->
    <div class="column col-12">
        <!--<h4>{{dataService.raceProfiles.backyard2023.eventName}}</h4>-->
        <!--EVENT IS CURRENTLY RUNNING-->
        <div *ngIf="dataService.raceStarted">
            <!--<span class="hint">The WausaUltra Backyard is Underway!</span><br />-->
            <div class="row col-12 race-info-section">
                <div class="col-4 a-center lap-info">
                    <p style="font-size:1.2em;"><strong>Current Lap: </strong><br />
                        <span class="current-lap">{{dataService.raceProfiles.backyard2023.lapCounter+1}}</span></p>
                    <p><strong>Laps Completed: </strong><br />
                        <span class="completed-laps">{{dataService.raceProfiles.backyard2023.lapCounter}}</span></p>
                </div>
                <div class="col-4 a-center time-info">
                    <p style="font-size:1.2em;"><strong>Lap Time Remaining: </strong><br />
                        <span class="lap-time">{{helperService.friendlyTimeDuration(dataService.lapTimeRemainingMS(), 'ms')}}</span></p>
                    <p><strong>Race Time Elapsed: </strong><br />
                        <span class="total-race-time">{{dataService.raceProfiles.backyard2023.timeElapsed}}</span></p>
                    <p class="hint"><strong>Current Time: </strong><br />
                        <span class="current-time">{{helperService.friendlyTime(now)}}</span></p>
                </div>
                <div class="col-4 a-center racer-info">
                    <p style="font-size:1.2em;"><strong>Remaining In Race: </strong><br />
                        <span>{{dataService.raceProfiles.backyard2023.lapCompletedRacers.length + dataService.raceProfiles.backyard2023.racersOnCourse.length}}</span></p>
                    <p><strong>On Course: </strong><br />
                        <span>{{dataService.raceProfiles.backyard2023.racersOnCourse.length}}</span></p>
                    <p><strong>Completed Lap: </strong><br />
                        <span>{{dataService.raceProfiles.backyard2023.lapCompletedRacers.length}}</span></p>
                </div>
            </div>
            <hr />
            <div class="bib-checkin">
                <form [formGroup]="lapBibSubmission">
                    <div class="col-12 row">
                        <div class="col-2"></div>
                        <label class="col-2 a-center">Bib #</label>
                        <input class="form-control col-3" type="number" formControlName="bib" (keyup)="bibLookup('backyard2023')" />
                        <div class="col-3 a-center">
                            <button class="btn btn-outline-primary" (click)="lapCompleted('backyard2023')">Finish Lap</button>
                        </div>
                        <div class="col-2"></div>
                    </div>
                    <div class="col-12 row container-md" *ngIf="bibLoadedRacer.firstName">
                        <div class="col-2">
                            <img src="{{bibLoadedRacer.profileImageUrl}}" *ngIf="bibLoadedRacer.profileImageUrl" />
                        </div>
                        <div class="col-6">
                            <span>Racer Located: {{bibLoadedRacer.firstName}} {{bibLoadedRacer.lastName}}</span><br />
                            <span>Laps Completed: {{helperService.racerLapsCompleted(bibLoadedRacer)}}</span><br />
                            <span>Total Time On Course: {{helperService.racerTimeOnCourse(bibLoadedRacer, dataService.raceProfiles.backyard2023)}}</span>
                        </div>
                        <div class="col-4">
                            <ul>
                                <li>Current Lap Time Elapsed: {{helperService.friendlyTimeDuration(((1000*60*10) - dataService.raceProfiles.backyard2023.lapTimeRemainingMS), 'ms')}}</li>
                                <li>Division: {{helperService.racerDivision(bibLoadedRacer)}}</li>
                            </ul>
                        </div>
                    </div>
                </form>
            </div>
            <hr />
            <br /><br />
            <div class="racer-bibs">
                <ul>
                    <li>Runners on Course: {{dataService.raceProfiles.backyard2023.racersOnCourse.length}}
                        <ul class="bib-list on-course">
                            <li *ngFor="let bibNo of dataService.raceProfiles.backyard2023.racersOnCourse" class="bib-icon" style="cursor:pointer" (click)="setBibToForm(bibNo)">
                                <span>{{bibNo}}</span>
                            </li>
                        </ul>
                    </li>
                    <li>Runners Completed Lap: {{dataService.raceProfiles.backyard2023.lapCompletedRacers.length}}
                        <ul class="bib-list completed">
                            <li *ngFor="let bibNo of dataService.raceProfiles.backyard2023.lapCompletedRacers" class="bib-icon"><span>{{bibNo}}</span></li>
                        </ul>
                    </li>
                    <li *ngIf="dataService.completedLaps">Last 5 Lap Records: <ul>
                        <li *ngFor="let lapRecord of dataService.completedLaps">
                            {{lapRecord.firstName}} {{lapRecord.lastName}} : {{lapRecord.bibNumber}} ({{lapRecord.division}}): Lap Time {{helperService.friendlyTimeDuration(lapRecord.lapTime, 'ms')}}
                        </li>
                    </ul></li>
                </ul>
            </div>
        </div>

        <!--EVENT HAS FINISHED-->
        <!-- this was displayed while still ongoing while in testing yet.... -->
        <div *ngIf="dataService.raceFinished" style="padding:60px 20px;">
            <h4>This race has finished</h4>
            <span>Please see the <a href="/tracking">Tracking</a> page for the final leader board results.</span>
        </div>

        <!--EVENT HAS NOT STARTED YET-->
        <div class="countdown col-12 column" *ngIf="!dataService.raceStarted && !dataService.raceFinished">
            <div style="text-align:center; padding-bottom:20px;">
                <span style="font-size:2em;">Event will start in: {{countdown}}</span><br />
            </div>
            <div class="col-12 row">
                <div class="col-6">
                    <span style="padding-top:4px; display:inline-block;">
                        {{dataService.raceProfiles.backyard2023.racersCheckedInCount}} Runners Are Ready to Roll!
                        <span class="note"> - Missing {{dataService.raceProfiles.backyard2023.totalRacersInEvent - dataService.raceProfiles.backyard2023.racersCheckedInCount}}</span>
                    </span>
                    <hr/>
                    <div *ngFor="let racer of dataService.racers">
                        <div *ngIf="racer.checkedIn" class="present-racer">
                            <span class="bib-icon">{{racer.backyard2023.bibNumber}}</span>
                            <span>{{racer.firstName}} {{racer.lastName}}</span>
                            <span *ngIf="racer.profileImageUrl">
                                <img class="racer-profile" src="{{racer.profileImageUrl}}" />
                            </span>
                            <span class="action-button">
                                <button class="btn btn-round btn-icon btn-mini" (click)="toggleCheckedIn(racer)">
                                    <i class="fa fa-minus-circle"></i>
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <h4>Racers NOT Checked In</h4>
                    <hr/>
                    <div *ngFor="let racer of dataService.racers">
                        <!--build out a list of all of the racers not yet checked in.-->
                        <div *ngIf="!racer.checkedIn && racer.backyard2023" class="missing-racer">
                            <span class="bib-icon">{{racer.backyard2023.bibNumber}}</span>
                            <span>{{racer.firstName}} {{racer.lastName}}</span>
                            <span *ngIf="racer.profileImageUrl">
                                <img class="racer-profile" src="{{racer.profileImageUrl}}" />
                            </span>
                            <span class="action-button">
                                <button class="btn btn-round btn-icon btn-mini" (click)="toggleCheckedIn(racer)">
                                    <i class="fa fa-plus-circle"></i>
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</div>
